import React from 'react';
import PropTypes from 'prop-types';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDStack } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { TitleTextLarge } from 'Packages/FacetDesign/Components';
import { Layout } from './Layout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('scenarioName', {
    _component: () => TitleTextLarge,
  }, overrideReadOnly);


export const Content = ({
  collection,
}) => {
  return (
    <FDStack direction={'column'} spacing={4}>
      {collection.resources().list().map((resource) => {
        return (
          <MetaResourceRenderer
            resource={resource}
            layout={Layout}
            metaOverrideSet={metaOverrideSet}
          />
        );
      })}
    </FDStack>
  );
};

Content.propTypes = {
  collection: PropTypes.object.isRequired,
};
